import { ActionRoleType } from '../../../settings/acciones-roles/type';

const fullAccess = [
  'Chief',
  'Admin',
  'Viewer',
  'LidAdmin',
  'LidChief',
  'LidSupervisor',
  'LidViewer',
];

export const LIDS_ROLES_VIEWS_PERMISSIONS: ActionRoleType = {
  sharedActions: {
    addWorkOrder: [...fullAccess, 'LidEngineer', 'LidLeader'],
    scheduler: [...fullAccess, 'LidEngineer', 'LidOperator', 'LidLeader'],
    validation: [...fullAccess, 'LidEngineer', 'LidLeader'],
    packingBox: [...fullAccess, 'LidLeader', 'LidLabel', 'LidQc'],
  },

  sideNavActions: {
    // No hay rutas exclusivas del router
    root: [
      ...fullAccess,
      'LabelOperator',
      'LidOperator',
      'LidLabel',
      'LidQc',
      'LidLeader',
      'LidEngineer',
    ],
  },
};
